import React from 'react'
// eslint-disable-next-line camelcase
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'
import WelcomeModal from '@/modules/onboardingV2/components/welcome-modal'
import waitForTrialSubscription from './wait-for-trial-subscription'

/**
 * Shows the welcome screen once the registration is finished. The onboarding modal closes at the
 * same time, so the welcome screen lives in the global portal.
 * It waits for the trial subscription: "Erste Rechnung schreiben" would otherwise open the invoice
 * just before the start of the trial navigates away from it.
 */
const openWelcomeModal = async(onClosed?: () => void) => {
  if (typeof renderElement !== 'function') {
    onClosed?.()
    return
  }

  await waitForTrialSubscription()

  renderElement(close => (
    <WelcomeModal
      onClose={() => {
        close()
        onClosed?.()
      }}
    />
  ))
}

export default openWelcomeModal
